
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import confirmer from './confirmer'
import teams from './teams'
import meals from './meals'
import nutrikiosk from './nutrikiosk'
import shdl from './shdl'
import craps from './craps'
import surveys from './surveys'

const axios = require("axios")
import _ from 'lodash'
import config from '@/config'

Vue.use(Vuex)

// persist vuex state into localStorage
const vuexLocalStorage = new VuexPersist({
   strictMode: true, // This **MUST** be set to true
   key: 'vuex', // The key to store the state on in the storage provider.
   storage: window.localStorage, // or window.sessionStorage or localForage
   // Function that passes the state and returns the state with only the objects you want to store.
   // reducer: state => state,
   // Function that passes a mutation and lets you decide if it should update the state in localStorage.
   // filter: mutation => (true)
})


function resetState(state) {
    Object.assign(state, {
        appHeight: 0,

        authenticationData: null,
        loggedUserId: null,
        waiting: false,
        snackbar: false,
        snackbarOptions: {},

        realms: {},
        roles: {},

        users: {},
        user2coachedUserList: {}, // userId -> list of coachedUser ids

        userAttributes: {},
        user2userAttributeList: {},
        user2attribute2datedValues: {},

        messages: {},
        user2messageList: {},
        user2unreadMessageCount: {},

        events: {},
        user2eventList: {},
        team2eventList: {},
    })
}

const state = {
    // unresettable part of state
    httpReferer: null, // 'nutrieduc', 'shdl'
}
resetState(state)


/*
// from https://github.com/axios/axios/issues/960
axios.interceptors.response.use((response) => {
   return response
}, function (error) {
   console.log(error.response)
   // Do something with response error
   if (error.response.status === 401) {
       console.log('unauthorized, logging out ...')
       auth.logout();
       router.replace('/auth/login');
   }
   return Promise.reject(error.response);
})
*/

const mutations = {
   
   RESTORE_MUTATION: vuexLocalStorage.RESTORE_MUTATION, // this mutation **MUST** be named "RESTORE_MUTATION"
    
   RESET_STATE (state) {
      console.log('RESET_STATE')
      // reset root state
      resetState(state)
      // reset other modules states
      this.commit('teams/RESET_STATE')
      this.commit('meals/RESET_STATE')
      this.commit('nutrikiosk/RESET_STATE')
      this.commit('shdl/RESET_STATE')
      this.commit('craps/RESET_STATE')
      this.commit('surveys/RESET_STATE')
   },

   SET_APP_HEIGHT (state, height) {
      state.appHeight = height
   },

   WAITING (state, value) {
      state.waiting = value
   },

   SNACKBAR (state, options) {
      state.snackbar = true
      state.snackbarOptions = options
   },

   SNACKBAR_SET (state, value) {
      state.snackbar = value
   },

   SET_HTTP_REFERER (state, httpReferer) {
      state.httpReferer = httpReferer
   },

   SET_AUTHENTICATION_DATA (state, authenticationData) {
      state.authenticationData = authenticationData
   },

   SET_LOGGED_USER (state, user) {
      state.users[user.id] = user
      state.loggedUserId = user.id
   },

   UPDATE_AUTHENTICATION_STATUS (state) {
      try {
         verifyToken(state.authenticationData.token, state.authenticationData.publicKey)
      } catch(e) {
         this.commit('RESET_STATE')
      }
   },

   SET_REALMS (state, realms) {
      realms.forEach(function(realm) {
         Vue.set(state.realms, realm.id, realm)
      })
   },

   SET_ROLES (state, roles) {
      roles.forEach(function(role) {
         Vue.set(state.roles, role.id, role)
      })
   },

   ADD_USER (state, user) {
      Vue.set(state.users, user.id, user)
   },

   SET_USER (state, user) {
      Vue.set(state.users, user.id, user)
   },

   REMOVE_USER (state, userId) {
      // remove it from state.user2coachedUserList (in case it is a caregiver)
      Vue.delete(state.user2coachedUserList, userId)
      // remove it also from all coachedUserList (in case it is a coached user)
      for (let caregiverId in state.user2coachedUserList) {
         let coachedUserList = state.user2coachedUserList[caregiverId]
         let index = coachedUserList.indexOf(userId)
         if (index !== -1) {
            let clonedPatientList = _.clone(coachedUserList)
            clonedPatientList.slice(index, 1)
            Vue.set(state.user2coachedUserList, caregiverId, clonedPatientList)
         }
      }

      // À COMPLÉTER

      // remove it from state.user2mealList
      //Vue.delete(state.user2mealList, userId)
      // remove it from state.user2moduleList
      //Vue.delete(state.user2moduleList, userId)



      // remove it from state.user2messageList
      Vue.delete(state.user2messageList, userId)
      // remove it from state.users
      Vue.delete(state.users, userId)
   },

   // make sure users are all registered in state
   CREATE_OR_SET_EACH_USER (state, users) {
      users.forEach(user => { Vue.set(state.users, user.id, user) })
   },

   // set coached users of the (coach) logged-in user
   SET_COACHED_USERS (state, coachedUserList) {
      Vue.set(state.user2coachedUserList, state.loggedUserId, coachedUserList.map(coachedUser => coachedUser.id))
   },

   SET_USER_MESSAGES (state, { userId, messages }) {
      messages.forEach(message => {
         state.messages[message.id] = message
      })
      Vue.set(state.user2messageList, userId, messages.map(message => message.id))
   },

   ADD_USER_MESSAGE (state, message) {
      // add message to state.messages
      Vue.set(state.messages, message.id, message)
      // add message to state.user2messageList
      if (!state.user2messageList.hasOwnProperty(message.user)) state.user2messageList[message.user] = []
      state.user2messageList[message.user].push(message.id)
   },

   UPDATE_USER_MESSAGE (state, message) {
      Vue.set(state.messages, message.id, message)
   },

   SET_UNREAD_MESSAGES_COUNT (state, { userId, count }) {
      Vue.set(state.user2unreadMessageCount, userId, count)
   },

   SET_USER_HISTORY_EVENTS (state, { userId, events }) {
      events.forEach(event => {
         state.events[event.id] = event
      })
      Vue.set(state.user2eventList, userId, events.map(event => event.id))
   },

   ADD_USER_HISTORY_EVENT (state, event) {
      // add event to state.events
      Vue.set(state.events, event.id, event)
      // add event to state.user2eventList
      if (!state.user2eventList.hasOwnProperty(event.user)) state.user2eventList[event.user] = []
      state.user2eventList[event.user].push(event.id)
   },

   SET_TEAM_HISTORY_EVENTS (state, { teamId, events }) {
      events.forEach(event => {
         state.events[event.id] = event
      })
      Vue.set(state.team2eventList, teamId, events.map(event => event.id))
   },

   ADD_TEAM_HISTORY_EVENT (state, event) {
      // add event to state.events
      Vue.set(state.events, event.id, event)
      // add event to state.team2eventList
      if (!state.team2eventList.hasOwnProperty(event.user)) state.team2eventList[event.user] = []
      state.team2eventList[event.team].push(event.id)
   },

   SET_USER_ATTRIBUTES (state, { userId, attributes }) {
      attributes.forEach(attribute => {
         state.userAttributes[attribute.id] = attribute
      })
      Vue.set(state.user2userAttributeList, userId, attributes.map(attribute => attribute.id))
   },

   SET_USER_ATTRIBUTE_DATED_VALUES (state, { userId, attributeId, datedValues }) {
      if (!state.user2attribute2datedValues.hasOwnProperty(userId)) state.user2attribute2datedValues[userId] = {}
      if (!state.user2attribute2datedValues[userId].hasOwnProperty(attributeId)) state.user2attribute2datedValues[userId][attributeId] = {}
      Vue.set(state.user2attribute2datedValues[userId], attributeId, datedValues)
   },

   ADD_USER_ATTRIBUTE_DATED_VALUE (state, datedValue) {
      let userId = datedValue.user
      let attributeId = datedValue.attribute
      let datedValues = state.user2attribute2datedValues[userId][attributeId]
      datedValues.push(datedValue)
      Vue.set(state.user2attribute2datedValues[userId], attributeId, datedValues)
   },

   REMOVE_USER_ATTRIBUTE_DATED_VALUE (state, datedValue) {
      let userId = datedValue.user
      let attributeId = datedValue.attribute
      let datedValues = state.user2attribute2datedValues[userId][attributeId]
      datedValues = datedValues.filter((dv) => dv.id !== datedValue.id)
      Vue.set(state.user2attribute2datedValues[userId], attributeId, datedValues)
   }

}

const actions = {

   GET_HTTP_REFERER ({ commit, state }) {
      return axios({
         method: 'get',
         url: `${config.HTTP_REFERER_URL}`,
      })
      .then(function(response) {
         commit('SET_HTTP_REFERER', response.data)
         return response.data
      })
   },

   GET_REALMS ({ commit, state }) {
      return axios({
         method: 'get',
         url: `${config.REALMS_URL}`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_REALMS', response.data)
         return response.data
      })
   },

   GET_ROLES ({ commit, state }) {
      return axios({
         method: 'get',
         url: `${config.ROLES_URL}`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_ROLES', response.data)
         return response.data
      })
   },

   IS_USERNAME_AVAILABLE ({ commit, state }, username) {
      return axios({
         method: 'get',
         url: `${config.USERS_URL}?username=${username}`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         return response.data.length === 0
      })
   },

   GET_USERS ({ commit, state }) {
      return axios({
         method: 'get',
         url: config.USERS_URL,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         commit('CREATE_OR_SET_EACH_USER', response.data)
         return response.data
      })
   },

   GET_USER ({ commit, state }, userId) {
      return axios({
         method: 'get',
         url: `${config.USERS_URL}${userId}/`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_USER', response.data)
         return response.data
      })
   },

   // used when creating user from sign-up form, doesn't need to be authenticated
   // user is not active until having been activated
   CREATE_USER: async function({ commit, state }, data) {
      let userId = await axios({
         method: 'post',
         url: config.CREATE_USER_URL,
         data: data,
      })
      return userId
   },

   SEND_ACTIVATE_ACCOUNT_MAIL ({ commit, state }, userId) {
      return axios({
         method: 'post',
         url: config.ACTIVATE_ACCOUNT_MAIL_URL,
         data: {"userId": userId},
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
   },

   // used when creating user from user-management module ; needs authentication
   POST_USER ({ commit, state }, user) {
      return axios({
         method: 'post',
         url: config.USERS_URL,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
         data: user,
      })
      .then(function(response) {
         commit('ADD_USER', response.data)
         return response.data
      })
      .catch(function(error) {
         throw new Error(error.response.status)
      })
   },

   PUT_USER ({ commit, state }, user) {
      return axios({
         method: 'put',
         url: `${config.USERS_URL}${user.id}/`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
         data: user,
      })
      .then(function(response) {
         commit('SET_USER', response.data)
         return response.data
      })
   },

   DELETE_USER ({ commit, state }, userId) {
      return axios({
         method: 'delete',
         url: `${config.USERS_URL}${userId}/`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         commit('REMOVE_USER', userId)
         return userId
      })
   },

   // fetch coachedUserList associated to current (coach) user
   GET_COACHED_USERS ({ commit, state }) {
      return axios({
         method: 'get',
         url: config.COACHED_USERS_URL,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         commit('CREATE_OR_SET_EACH_USER', response.data)
         commit('SET_COACHED_USERS', response.data)
         return response.data
      })
   },

   GET_USER_MESSAGES ({ commit, state }, userId) {
      return axios({
         method: 'get',
         url: `${config.MESSAGES_URL}?user=${userId}`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         let userMessagesDict = { userId: userId, messages: response.data }
         commit('SET_USER_MESSAGES', userMessagesDict)
         return response.data
      })
   },

   PUT_USER_MESSAGE ({ commit, state }, message) {
      return axios({
         method: 'put',
         url: `${config.MESSAGES_URL}${message.id}/`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
         data: message,
      })
      .then(function(response) {
         commit('UPDATE_USER_MESSAGE', response.data)
         return response.data
      })
   },
   
   POST_USER_MESSAGE ({ commit, state }, message) {
      return axios({
         method: 'post',
         url: config.MESSAGES_URL,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
         data: message,
      })
      .then(function(response) {
         commit('ADD_USER_MESSAGE', response.data)
         return response.data
      })
   },

   COUNT_UNREAD_MESSAGES  ({ commit, state }, userId) {
      return axios({
         method: 'get',
         url: `${config.MESSAGES_URL}?user=${userId}&visible_by=${state.loggedUserId}&unread_by=${state.loggedUserId}`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         let dict = { userId: userId, count: response.data.length }
         commit('SET_UNREAD_MESSAGES_COUNT', dict)
         return response.data.length
      })
   },

   GET_USER_HISTORY_EVENTS ({ commit, state }, userId) {
      return axios({
         method: 'get',
         url: `${config.HISTORY_EVENT_URL}?user=${userId}`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         let userHistoryDict = { userId: userId, events: response.data }
         commit('SET_USER_HISTORY_EVENTS', userHistoryDict)
         return response.data
      })
   },

   GET_TEAM_HISTORY_EVENTS ({ commit, state }, teamId) {
      return axios({
         method: 'get',
         url: `${config.HISTORY_EVENT_URL}?team=${teamId}`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         let teamHistoryDict = { teamId: teamId, events: response.data }
         commit('SET_TEAM_HISTORY_EVENTS', teamHistoryDict)
         return response.data
      })
   },
   
   POST_HISTORY_EVENT ({ commit, state }, event) {
      return axios({
         method: 'post',
         url: config.HISTORY_EVENT_URL,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
         data: event,
      })
      .then(function(response) {
         if (event.user) {
            commit('ADD_USER_HISTORY_EVENT', response.data)
         } else if (event.team) {
            commit('ADD_TEAM_HISTORY_EVENT', response.data)
         }
         return response.data
      })
   },

   GET_USER_ATTRIBUTES ({ commit, state }, userId) {
      return axios({
         method: 'get',
         url: `${config.USER_ATTRIBUTES_URL}?user=${userId}`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         let userAttributesDict = { userId: userId, attributes: response.data }
         commit('SET_USER_ATTRIBUTES', userAttributesDict)
         return response.data
      })
   },

   GET_USER_ATTRIBUTE_DATED_VALUES ({ commit, state }, { userId, attributeId, start, end}) {
      return axios({
         method: 'get',
         url: `${config.USER_ATTRIBUTE_DATED_VALUES_URL}?user=${userId}&attribute=${attributeId}&start=${start}&end=${end}`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         let responseDict = { userId: userId, attributeId: attributeId, datedValues: response.data }
         commit('SET_USER_ATTRIBUTE_DATED_VALUES', responseDict)
         return response.data
      })
   },
   
   POST_USER_ATTRIBUTE_DATED_VALUE ({ commit, state }, datedValue) {
      return axios({
         method: 'post',
         url: config.USER_ATTRIBUTE_DATED_VALUES_URL,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
         data: datedValue,
      })
      .then(function(response) {
         commit('ADD_USER_ATTRIBUTE_DATED_VALUE', response.data)
         return response.data
      })
   },
   
   DELETE_USER_ATTRIBUTE_DATED_VALUE ({ commit, state }, datedValue) {
      return axios({
         method: 'delete',
         url: `${config.USER_ATTRIBUTE_DATED_VALUES_URL}${datedValue.id}/`,
         headers: {"Authorization": `JWT ${state.authenticationData.token}`},
      })
      .then(function(response) {
         commit('REMOVE_USER_ATTRIBUTE_DATED_VALUE', datedValue)
      })
   },

}


const getters = {

   platform: function(state) {
      if (state.httpReferer) {
         if (state.httpReferer.indexOf('shdl') !== -1) {
            return 'shdl'
         } else {
            return 'nutrieduc'
         }
      } else {
         return null
      }
   },

   // authenticated user
   loggedInUser: state => state.users[state.loggedUserId],

   // roles of authenticated user
   loggedInUserRoles: function(state, getters) {
      let roles = {}
      try {
         let roleIds = getters.loggedInUser.roles
         for (let i = 0; i < roleIds.length; i++) {
            let roleId = roleIds[i]
            if (state.roles.hasOwnProperty(roleId)) {
               let role = state.roles[roleId]
               roles[role.uid] = role
            }
         }
      } catch(e) {
      }
      return roles
   },

   firstGroup: function(state, getters) {
      if (state.loggedInUserId) {
         let roleIds = getters.loggedInUser.roles
         return state.roles[roleIds[0]]
      } else {
         return undefined
      }
   },

   loggedInUserRealms: function(state, getters) {
      let realm_ids = []
      for (let roleUid in getters.loggedInUserRoles) {
         let role = getters.loggedInUserRoles[roleUid]
         if (role.realm !== null && realm_ids.indexOf(role.realm) === -1) {
            realm_ids.push(role.realm)
         }
      }
      return realm_ids.map(realm_id => state.realms[realm_id])
   },

   appParams: function(state, getters) {
      if (getters.firstGroup) {
         return getters.firstGroup.params
      } else {
         return {}
      }
   },

   // authorizations of authenticated user
   authorized: function(state, getters) {
      let authorized = {}
      for (let roleUid in getters.loggedInUserRoles) {
         let role = getters.loggedInUserRoles[roleUid]
         for (let i = 0; i < role.authorizations.length; i++) {
            let activity = role.authorizations[i]
            if (!authorized.hasOwnProperty(activity.uid)) authorized[activity.uid] = activity
         }
      }
      return authorized
   },

   // list of authorization uid's
   authorizedList: function(state, getters) {
      let list = []
      for (let roleUid in getters.loggedInUserRoles) {
         let role = getters.loggedInUserRoles[roleUid]
         for (let i = 0; i < role.authorizations.length; i++) {
            let activity = role.authorizations[i]
            if (list.indexOf(activity.uid) === -1) list.push(activity.uid)
         }
      }
      return list
   },

   // coached users of the (coach) authenticated user
   coachedUsers: state => state.user2coachedUserList.hasOwnProperty(state.loggedUserId) ? state.user2coachedUserList[state.loggedUserId].map(userId => state.users[userId]) : [],

}


export default new Vuex.Store({
   //strict: process.env.NODE_ENV !== 'production',
   strict: true, // This makes the Vuex store strict
   state,
   modules: {
      confirmer,
      teams,
      meals,
      nutrikiosk,
      shdl,
      craps,
      surveys,
   },
   mutations,
   getters,
   actions,
   plugins: [vuexLocalStorage.plugin],
})




// WEBPACK FOOTER //
// ./src/store/index.js